'use client';

import dynamic from 'next/dynamic';
import { useEffect, useRef, useState } from 'react';

import { FeaturedItem } from '@/types/home/home.types';
import { Range } from '@/types/request/request.types';

const Promotions = dynamic(
  () => import('@/app/_components/promotions/Promotions'),
  {
    loading: () => <div style={{ minHeight: 700 }} />,
  },
);

interface Props {
  promotionsItems: FeaturedItem[];
  ranges: Range[];
}

const LazyRecommendedPromotions = ({
  promotionsItems,
  ranges,
}: Props) => {
  const recommendedRef = useRef<HTMLDivElement>(null);
  const [shouldLoadRecommended, setShouldLoadRecommended] = useState(false);

  useEffect(() => {
    const element = recommendedRef.current;

    if (!element) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry) return;

        if (entry.isIntersecting) {
          setShouldLoadRecommended(true);
          observer.disconnect();
        }
      },
      {
        rootMargin: '500px',
      },
    );

    observer.observe(element);

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <div ref={recommendedRef} style={{ minHeight: 700 }}>
      {shouldLoadRecommended && (
        <Promotions
          isShowNavigation
          featuredItems={promotionsItems as any[]}
          sectionTitle="Recommended Promotions"
          ranges={ranges}
        />
      )}
    </div>
  );
};

export default LazyRecommendedPromotions;